// extracted by mini-css-extract-plugin
module.exports = {"avSettingsHolder":"AVSettingsSidebar_avSettingsHolder__2pbvg"};